<template>
  
  <v-data-table dense
                :headers="headers()"
                :items="EvLista"
                class="elevation-1"
                :pagination.sync="pagination">
    <template v-slot:items="props">
        <tr :class="getBojuRetkaZaispit(props.item)">
          <td :class="getBojuRetkaZaispit(props.item)">
            <div v-if="props.item.Children.length < 2">
              {{ props.item.Datum | moment('DD.MM.YYYY') }}
            </div>
            <div class="text-xs-center" v-else>
              <v-icon color="red">mdi-arrow-down</v-icon>
            </div>
          </td>
          <td :class="getBojuRetkaZaispit(props.item, 'text-xs-left')">
            {{ props.item.Usluga  }}
          </td>
          <td class="black--text text-xs-left">{{ props.item.Predavac }}</td>
          <td :class="getPrisutnostKlasa(props.item.OstvarioPotrebno)">
            <small v-if="props.item.Prisutnost != null && props.item.Prisutnost.startsWith('server_msg')">
              {{ $t(props.item.Prisutnost) }}
            </small>
            <span v-else>
              {{ props.item.Prisutnost }} <span v-if="props.item.Prisutnost"> % </span>
            </span>
          </td>
          <td class="black--text text-xs-center">        
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon dark v-on="on" :class="getPolozioClass(props.item.Polozio)">{{ getStatusIcon(props.item.Polozio) }}</v-icon>
              </template>
              <span>{{ getPolozioDescription(props.item.Polozio) }}</span>
            </v-tooltip>
          </td>
        </tr>
        <!--Završni ispiti su kao child elementi, njih posebno prikažem...iako na kraju izgleda isto-->
        <tr v-if="props.item.Children.length > 1" v-for="c in props.item.Children">
          <!--<td colspan="5">
    <table>-->
          <td>{{ c.Datum | moment('DD.MM.YYYY') }}</td>
          <td :class="getBojuRetkaZaispit('', 'text-xs-left')">{{ c.Usluga  }}</td>
          <td class="black--text text-xs-left">{{ c.Predavac }}</td>
          <td :class="getPrisutnostKlasa(c.OstvarioPotrebno)">
            <small v-if="c.Prisutnost != null && c.Prisutnost.startsWith('server_msg')">
              {{ $t(c.Prisutnost) }}
            </small>
            <span v-else>
              {{ c.Prisutnost }}
            </span>
          </td>
          <td class="black--text text-xs-center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon dark v-on="on" :class="getPolozioClass(c.Polozio)">{{ getStatusIcon(c.Polozio) }}</v-icon>
              </template>
              <span>{{ getPolozioDescription(c.Polozio) }}</span>
            </v-tooltip>
          </td>
          <!--</table>
    </td>-->
        </tr>
    </template>
  </v-data-table>

</template>

<script>
  export default {
    name: 'EvidencijskaLista',
    props: {
      EvLista: { type: Array }
    },

    methods: {
      getPrisutnostKlasa(ostvario) {

        switch (ostvario) {
          case true: return 'green--text text-xs-center';
          case false: return 'red--text text-xs-center';
          default: 'black--text text-xs-center';
        }
      },

      getPolozioDescription(status) {
        switch (status) {
          case -5: return '';
          case 1: return this.$t('ev_lista.exam_result._1');
          case 2: return this.$t('ev_lista.exam_result._2');
          case 3: return this.$t('ev_lista.exam_result._3');
          case 4: return this.$t('ev_lista.exam_result._4');
          default:
        }
      },

      getPolozioClass(status) {
        switch (status) {
          case -5: return '';
          case 1: return 'green--text'
          case 2: return 'red--text'
          case 3: return 'orange--text'
          case 4: return 'blue--text'
          default:
        }
      },

      getStatusIcon(status) {
        switch (status) {
          case -5: return '';
          case 1: return 'mdi-check-circle'
          case 2: return 'mdi-close-circle'
          case 3: return 'mdi-alert'
          case 4: return 'mdi-clock'
          default:
        }
      },


      getBojuRetkaZaispit(item, orientation) {
        if (item.TipUsluge_ID == 1) {
          return 'black--text grey lighten-4 ' + orientation
        } else {
          return orientation;
        }
      },

      headers() {
        return [
          {
            sortable: false,
            text: this.$t('ev_lista.table_view_headers.event_date'),
            value: 'Datum'
          },
          {
            sortable: false,
            text: this.$t('ev_lista.table_view_headers.event_name'),
            value: 'Ime'
          },
          {
            sortable: false,
            text: this.$t('ev_lista.table_view_headers.event_lecturer'),
            value: 'Predavac'
          },
          {
            sortable: false,
            text: this.$t('ev_lista.table_view_headers.event_presence'),
            value: 'Prisutnost',
            align: 'center'
          },
          {
            sortable: false,
            text: this.$t('ev_lista.table_view_headers.event_status'),
            value: 'Status'
          },
        ]
      },
    },

    data() {
      return {

        pagination: {
          rowsPerPage: -1
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// VueSrc/Exams/presence_exam_results/EvidencijskaLista.vue